<div class="body">
    <br />
    <div class="row">

        <div class="col-lg-5"> </div>

        <div class="center">
            <h1> Solicitud de Afiliación Funcionario Activo</h1>
        </div>

        <div class="col-lg-4"> </div>

    </div>
    <br />



    <div class="container">
        <div class="row">

            <div class="col-lg-1"> </div>
            <div class="col-lg-8"> </div>
            <div class="col-lg-3"> </div>

        </div>


        <br />
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-2">
                <h1> Rut Afiliado </h1>
            </div>

            <div class="col-lg-6">
           
                <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="data.rutAfiliado" #afiliado="ngModel"
                    class="form-control" type="text" required placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1"
                    pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1">
                <button class="btn btn-primary" id="btnvalida" (click)="BuscarAfiliadoExterno(data.rutAfiliado)"
                    [disabled]="afiliado.invalid ">
                    Buscar
                </button>

            </div>

            <div class="col-lg-1"> </div>

        </div>


        <br />
     
        <br />
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-8">
                <h2> Solicitud</h2>
            </div>

            <div class="col-lg-3"> </div>

        </div>
        <br />
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3"> <label> Tipo </label> </div>

            <div class="col-lg-5">

                <select id="ciudadCatastrofe" name="ciudadCatastrofe">
                    <option value="1">FUNCIONARIO ACTIVO </option>
                </select>
            </div>

        </div>
        <br />
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-2">
                <label> Nombre de funcionario </label>
            </div>
            <div class="col-lg-6">
                <input id="nombres" name="nombres" class="form-control"  #nombres="ngModel" [(ngModel)]="data.nombres" type="text" disabled />
            </div>
            <div class="col-lg-1"> </div>
            <div class="col-lg-1">
            </div>

            <div class="col-lg-1"> </div>

        </div>


        <br />
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-2"> <label> Correo electrónico</label> </div>

            <div class="col-lg-6">
                <input name="email" id="email" class="form-control"  [(ngModel)]="data.email"  type="text" disabled>
            </div>    
            <div class="col-lg-5">
              </div>
        </div>
        <br />

        <div class="row" *ngIf="data.mostrarDatosCargados == true">       
            <div class="col-lg-1"> </div>
            <div class="col-lg-2"> </div>   
            <div class="col-lg-5">
                ¿ Se encuentran correctos los datos cargados?
                Si <input type="radio" [checked]="true" (click)="MostrarCaip(false)" name="options" autocomplete="off">
                No <input type="radio" name="options"   (click)="MostrarCaip(true)" autocomplete="off">
            </div>
        </div>
        <br />
      
        <div class="row" *ngIf="data.mostrarCaip == true">
            <div class="col-lg-3"> </div>
            <div class="col-lg-8">
                Favor gestionar corrección de información mediante formulario CAIP.               
            </div>
        </div>
        <br/>
        <div class="row" *ngIf="data.mostrarCaip == true">
            <div class="col-lg-3"> </div>
            <div class="col-lg-2"> </div>   
            <div class="col-lg-5"> </div>
        </div>
           
        <div class="col-lg-8" *ngIf="data.mostrarCaip == true">
            <td class="col-lg-2"> </td>
            <td class="col-lg-6"> </td>
            <td class="col-lg-2">
                <button class="btn btn-primary" id="btnvalida" (click)="redireccionarCAIP()">
                    CAIP
                </button>
            </td>
        </div>

        <!--
        <div class="row" *ngIf="data.mostrarCalidadJuridica == true">
            <div class="col-lg-3"> </div>
            <div class="col-lg-8">
                <h3>
                Su calidad jurídica no cumple con requisito para cursar solicitud de
                afiliación según reglamento (Decreto 28, Titulo III Art.7°) <br> 
                </h3>                            
            </div>
        </div>
        <br/>
         -->
        <div class="row" *ngIf="data.mostrarCalidadJuridica == true">
            <div class="col-lg-3"> </div>
            <div class="col-lg-2"> </div>   
            <div class="col-lg-5"> </div>
        </div>
       
        <div class="col-lg-8" *ngIf="data.mostrarCalidadJuridica == true">
            <td class="col-lg-2"> </td>
            <td class="col-lg-6"> </td>
            <td class="col-lg-2">
                <button class="btn btn-primary" id="btnvalida" (click)="redireccionarHome()">
                    Salir
                </button>
            </td>
        </div>
      
        <div class="row" *ngIf="data.mostrarTerminosContinuar == true">
            <div class="col-lg-1"> </div>
            <div class="col-lg-8">
                <label> 
                    <h4>
                    Con fecha {{data.fechaActual}}, solicito mi afiliación o reincorporación como funcionario/a de la Junta  <br />
                    Nacional de Jardines Infantiles al Servicio de Bienestar de la institución, para cuyos fines autorizo, <br />
                     por una sola vez, el descuento de la cuota de incorporación que corresponde al 1% de mi  <br />
                     remuneración imponible y mensualmente el aporte de afiliación que corresponde al descuento <br />
                      del 1,6% de mi remuneración imponible.  
                      <br/> 
                      <br/>
                    Conforme al Reglamento del Servicio de Bienestar autorizo también, el descuento de las cuotas <br />
                     que me correspondan por hacer uso de los beneficios establecidos.
                   
                     <br/>
                     <br/>
                    Autorizo además que los beneficios solicitados en el Servicio de Bienestar sean depositados en <br/>
                    la cuenta bancaria donde recibo mi remuneración, en caso de no contar con una cuenta bancaria<br/>
                    estos serán pagados en modalidad vale vista (cash).                   
                    <br/>
                    <br/>
                    De acuerdo al mismo Reglamento, declaro conocer en todas sus partes mis deberes y<br/>
                    obligaciones de afiliado, las que asumiré desde el momento en que sea aceptada mi solicitud.
                    </h4>
                </label>
            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />
        <div class="row" *ngIf="data.mostrarTerminosContinuar == true">
            <div class="col-lg-6"> </div>
            <div class="col-lg-6">
                <input type="checkbox" [(ngModel)]="data.scales" id="scales" name="scales">
                <label for="scales"><h3>Acepto Términos y Condiciones</h3></label>
            </div>
            <div class="col-lg-8"></div>
        </div>
        <br />
        <div class="row line" *ngIf="data.mostrarTerminosContinuar == true">

            <div class="col-lg-2 col-sm-2"> </div>

            <div class="col-lg-4 col-sm-1"> </div>

            <div class="col-lg-3 col-sm-1">
                    <button class="boton-con-imagen"  (click)="AceptarPostulacion()">
                        <img class="btn" src="assets/img/clave.png"  alt="Aceptar postulación"  style="width:100%" />                        
                    </button>       
            <div class="col-lg-1 col-sm-1"> </div>

        </div>

    </div>
</div>

<div class="container" style="height:100px"> </div>